import styled from 'styled-components'

type Props = {
  selected?: boolean
}

const ItemRendererTitleInfo = styled.span<Props>`
  color: ${p => (p.selected ? p.theme.colors.$silver : p.theme.colors.$shadyLady)};
  font-size: ${p => p.theme.fonts.$p3};
  margin-top: 0;
  margin-bottom: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
  pointer-events: none;
`

ItemRendererTitleInfo.displayName = 'ItemRendererTitleInfo'
export default ItemRendererTitleInfo
